import { useMsal } from "@azure/msal-react";
import { AccountCircle } from "@material-ui/icons";
import React, { ReactElement } from "react";
import { Menu, MenuItem } from '@material-ui/core';
import { useUserInfoStyles } from "./userInfoStyles";
import { globalStyles } from "../../assets/globalStyles";
import IconExpandLess from '@material-ui/icons/ExpandLess'
import IconExpandMore from '@material-ui/icons/ExpandMore'
import { useStyles } from "../appMenu/appMenuStyples";

export default function UserInfo(): ReactElement {

   const { instance } = useMsal();
   const account = instance.getActiveAccount();

   const classes = {
      ...useUserInfoStyles(),
      ...globalStyles(),
      ...useStyles(),
   };

   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

   const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
   }

   const handleClose = () => {
      setAnchorEl(null);
   }

   return (
      <div style={{ marginLeft: "auto" }}>
         <MenuItem button className={classes.menuButton} onClick={handleClick}>
            <AccountCircle fontSize="large" style={{ marginRight: "10px" }} />
            {account?.name}
            {!anchorEl && <IconExpandMore />}
            {anchorEl && <IconExpandLess />}
         </MenuItem>
         <Menu
            id="userMenu"
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
            transformOrigin={{ vertical: 'top', horizontal: 'left', }}
            className={classes.subMenu}
         >
            <MenuItem className={classes.menuText}>Rollen: {account?.idTokenClaims?.roles?.join(", ")}</MenuItem>
            <MenuItem className={classes.menuButton} onClick={() => instance.acquireTokenRedirect({ prompt: "select_account", scopes: ["api://" + process.env.REACT_APP_API_CLIENT_ID + "/access_as_user"] })}>Als anderer Benutzer anmelden</MenuItem>
            <MenuItem className={classes.menuButton} onClick={() => instance.logout({ account: instance.getActiveAccount() || undefined })}>Abmelden</MenuItem>
         </Menu>
      </div >
   );
}